export default __webpack_public_path__ + "static/media/Pending.38b52c5c.svg";